export default "__VITE_ASSET__1a7214a1__"